var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44.411 43.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-phone",
    d: "M27.624,23.292v4.683a3.312,3.312,0,0,1-.9,2.313A2.594,2.594,0,0,1,24.6,31.1a25.614,25.614,0,0,1-11.987-4.793,29,29,0,0,1-8.334-9.367A33.442,33.442,0,0,1,.011,3.4,3.373,3.373,0,0,1,.726,1.017,2.65,2.65,0,0,1,2.775,0H6.942A2.9,2.9,0,0,1,9.72,2.685a22.106,22.106,0,0,0,.972,4.387,3.408,3.408,0,0,1-.625,3.294L8.3,12.349a23.792,23.792,0,0,0,8.334,9.367L18.4,19.733a2.56,2.56,0,0,1,2.931-.7,16.247,16.247,0,0,0,3.9,1.093,3.038,3.038,0,0,1,2.389,3.169Z",
    transform: "translate(43.001 21.409) rotate(130)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColl);
export default __webpack_public_path__ + "static/media/coll.391a7380.svg";
export { ForwardRef as ReactComponent };